import React from "react"
import { useSelector } from "react-redux"
import AddIcon from "@mui/icons-material/Add"
import { useNavigate } from "react-router-dom"
import PrimaryButton from "newcomponents/primary-button"

const Header = () => {
  const navigate = useNavigate()
  const mode = useSelector(state => state.Layout.layoutMode)
  const activeOrganization = useSelector(
    state => state.organizationReducer.activeOrganization,
  )

  const navigateToCreateCampaign = () => {
    navigate("/dashboard/create-campaign")
  }
  return (
    <div
     className="br"
      style={{
        backgroundColor: mode === "dark" ? "#252f40" : "#fff",
        marginTop: "0px",
        padding: "20px 20px",
        fontFamily: "Inter",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        color: mode === "dark" ? "#fff" : "#050409",
        fontWeight: "600",
        fontSize: "23px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: "20px",
      }}
    >
      {/* Left side: org name */}
      <h1>{activeOrganization?.name}</h1>

      {/* Right side: date inputs + button */}
      <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
        {/* Create New Button */}
        <PrimaryButton
          style={{
            padding: "15px 35px",
            fontSize: "20px",
            fontWeight: "500",
            borderRadius: "8px",
          }}
          icon={<AddIcon />}
          onClick={navigateToCreateCampaign}
        >
          Create New
        </PrimaryButton>
      </div>
    </div>
  )
}

export default Header
